module.exports = __webpack_public_path__ + "img/interface-1_en.30c7f8c.jpg";